import React from "react";
import Layout from "../components/common/Layout";

const PrivacyPolicy = () => {
  return (
    < Layout>
      <section className="relative min-h-screen text-white overflow-hidden">

        <div className="relative z-10 flex items-center justify-center min-h-screen px-6 py-20 backdrop-blur-md">
          <div className="bg-white/90 dark:bg-[#112626]/90 rounded-xl shadow-xl p-10 max-w-4xl text-gray-800 dark:text-gray-100 text-justify">

            <h1 className="text-3xl font-bold mb-6 text-center">SLOWORK PRIVACY POLICY</h1>
            <p className="mb-4 text-center">Effective Date: 27/02/2025</p>

            <h2 className="text-2xl font-semibold mt-6">1. Introduction</h2>
            <p className="mb-4">
              Slowork (hereinafter referred to as "we," "our," or "the Platform") is a platform designed to connect remote workers, digital nomads, and freelancers with natural environments that foster productivity and well-being. This Privacy Policy explains how we collect, use, share, and protect our users' personal data.
            </p>
            <p className="mb-4">
              By using our services, you agree to the practices described in this Privacy Policy. If you do not agree with its terms, please do not use the Platform.
            </p>

            <h2 className="text-2xl font-semibold mt-6">2. Data Controller</h2>
            <p className="mb-4">
              The data controller is Slowork S.L., located at Rodrigo Caro 7, Sevilla, 41004. Contact email: sloworking.adm@gmail.com.
            </p>

            <h2 className="text-2xl font-semibold mt-6">3. Personal Data We Collect</h2>
            <ul className="list-disc pl-6 mb-4">
              <li>Identification data: Name, surname, email address, date of birth, phone number.</li>
              <li>Account data: Username, password, and profile preferences.</li>
              <li>Payment data: Billing information and payment methods.</li>
              <li>Location data: IP address, geolocation data if enabled.</li>
              <li>Interaction data: Booking history, searches, reviews, and comments.</li>
              <li>Technical data: IP address, browser type, device, and operating system.</li>
              <li>Data from social networks: If you log in via Facebook, Google, LinkedIn, we may receive public profile info and data you authorize us to access.</li>
            </ul>

            <h2 className="text-2xl font-semibold mt-6">4. How We Use Your Data</h2>
            <ul className="list-disc pl-6 mb-4">
              <li>Facilitate the creation of user profiles and account management.</li>
              <li>Process bookings and transactions.</li>
              <li>Personalize the user experience on the Platform.</li>
              <li>Send promotional and service communications.</li>
              <li>Improve our services and features.</li>
              <li>Facilitate communication between users within the Platform.</li>
              <li>Comply with legal and regulatory obligations.</li>
              <li>Implement security measures and fraud prevention.</li>
            </ul>

            <h2 className="text-2xl font-semibold mt-6">5. Legal Basis for Data Processing</h2>
            <ul className="list-disc pl-6 mb-4">
              <li>Contract execution: To provide you with Platform services.</li>
              <li>Consent: For sending commercial communications and personalizing services.</li>
              <li>Legitimate interest: To improve our Platform and personalize the user experience.</li>
              <li>Legal obligations: Compliance with tax and security regulations.</li>
            </ul>

            <h2 className="text-2xl font-semibold mt-6">6. How We Share Your Data</h2>
            <ul className="list-disc pl-6 mb-4">
              <li>Service providers: Payment companies, web hosting, and technical support.</li>
              <li>Legal authorities: In case of legal requirements or regulatory compliance.</li>
              <li>Business partners: In case of integrations with third parties (e.g., affiliate programs).</li>
              <li>Social networks and third parties: If you choose to share information externally, we’re not responsible for how others use that data.</li>
            </ul>

            <h2 className="text-2xl font-semibold mt-6">7. Security and Data Breaches</h2>
            <p className="mb-4">
              We implement technical and organizational measures to protect personal data from unauthorized access, loss, or alteration. In the event of a security breach, we will notify authorities and affected users as required by applicable regulations.
            </p>

            <h2 className="text-2xl font-semibold mt-6">8. Data Retention</h2>
            <p className="mb-4">We retain personal data for as long as necessary to fulfill the purposes described in this Policy and comply with legal obligations.</p>

            <div className="overflow-auto mb-6">
              <table className="border-collapse border border-gray-400 w-full text-sm">
                <thead>
                  <tr className="bg-gray-200 dark:bg-gray-700">
                    <th className="border border-gray-400 p-2">Data Type</th>
                    <th className="border border-gray-400 p-2">Retention Period</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="border border-gray-400 p-2">Account data</td>
                    <td className="border border-gray-400 p-2">As long as the account is active or up to 5 years after inactivity</td>
                  </tr>
                  <tr>
                    <td className="border border-gray-400 p-2">Payment data</td>
                    <td className="border border-gray-400 p-2">10 years (due to tax and accounting regulations)</td>
                  </tr>
                  <tr>
                    <td className="border border-gray-400 p-2">Booking history</td>
                    <td className="border border-gray-400 p-2">3 years after the last booking</td>
                  </tr>
                  <tr>
                    <td className="border border-gray-400 p-2">Customer support communications</td>
                    <td className="border border-gray-400 p-2">2 years after inquiry</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <h2 className="text-2xl font-semibold mt-6">9. User Rights</h2>
            <p className="mb-4">
              Users have the right to access, rectify, delete, restrict, or object to data processing. You may contact the relevant data protection authority if needed.
            </p>

            <h2 className="text-2xl font-semibold mt-6">10. Cookies and Similar Technologies</h2>
            <p className="mb-4">
              We use cookies to enhance the user experience. You can manage your cookie preferences in your browser settings.
            </p>

            <h2 className="text-2xl font-semibold mt-6">11. Updates to the Privacy Policy</h2>
            <p className="mb-4">
              We reserve the right to modify this Policy at any time. Significant changes will be notified via email or platform notifications.
            </p>

            <h2 className="text-2xl font-semibold mt-6">12. Contact</h2>
            <p className="mb-4">
              If you have any questions, contact us at <strong>sloworking.adm@gmail.com</strong>.
            </p>

          </div>
        </div>
      </section>
    </Layout>
  );
};

export default PrivacyPolicy;
